/* ==================================================
   jQuery 3.x 専用スクリプト
   ================================================== */

jq3(function($){

  // 確認ログ
  console.log('jq3 ready:', $.fn.jquery);

  // テストクリック
  $('.js-sample').on('click', function(){
    alert('jq3 working');
  });

  // LINE登録Cookie制御
  if (Cookies.get('line_registered')) {
    return;
  }

  $('.promolayer-button').on('click', function(){
    Cookies.set('line_registered', 'true', { expires: 365 });
  });

});
